/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'monitor': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.9 12.23',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M18.4 0H.5a.5.5 0 000 1h1.06v3.35a7.88 7.88 0 1015.77 0V1h1.07a.5.5 0 000-1zm-2.07 4.35a6.88 6.88 0 11-13.77 0V1h13.77z" _fill="#c4c4c4"/><circle pid="1" cx="9.45" cy="5.58" r="2.41" _fill="#74777a"/></g></g>'
  }
})
